import { Component } from '@angular/core';
import { PlatformService } from '../../platform/platform.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {
  error = '';
  constructor(public platform: PlatformService) {}
  async change(event: Event) {
    try {
      await this.platform.select((event.target as HTMLSelectElement).value);
    } catch {
      this.error = 'Sessão indisponível. Entre novamente.';
    }
  }
}
